import React from "react";

const Footer = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center text-center"
      style={{
        backgroundColor: "black",
        color: "#fff",
        height: "70px",
        width: "100%",
        position: "absolute",
        bottom: "0px",
      }}
    >
      Online Examination System © Copyright , Inc. All Rights Reserved
    </div>
  );
};

export default Footer;
